module.exports = __webpack_public_path__ + "build/desktop/a/img/bus-icon.8b9798a3afc0e2e2b313558af744ff3e.svg";